import { SitesDetailsResponse } from './types';

/**
 * Select function to map the sites details response data to the data needed for the usage details table.
 * @param data - The sites details response data.
 * @returns The mapped sites details data.
 */
export function mapSitesDetailsRow(data: SitesDetailsResponse) {
  return {
    hasNextPage: data.hasNextPage,
    rows: data.data,
    totalCount: data.totalCount,
  };
}
